import { createReducer, createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  resetBooking: ['booking'],
  loadBookingRequest: ['bookingId'],
  setBookingData: ['data'],
  setBookingList: ['list'],
  setBookingLoading: ['loading']
});

export const BookingTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  loading: false,
  list: [],
  data: {}
};

/* ------- Selectors --------- */
export const BookingSelectors = {
  selectBookingsList: state => state.booking.list,
  selectIsLoading: state => state.booking.loading,
  selectBookingData: state => state.booking.data
};

/* -------- Reducers ---------- */

export const resetBooking = (state, { booking }) => {
  return {
    ...INITIAL_STATE,
    ...booking
  };
};

export const setBookingData = (state, { data }) => {
  return {
    ...state,
    data
  };
};

export const setBookingList = (state, { list }) => {
  return {
    ...state,
    list
  };
};

export const setBookingLoading = (state, { loading }) => {
  return {
    ...state,
    loading
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_BOOKING]: resetBooking,
  [Types.SET_BOOKING_LOADING]: setBookingLoading,
  [Types.SET_BOOKING_DATA]: setBookingData,
  [Types.SET_BOOKING_LIST]: setBookingList
});
